import { Component, Input, OnInit } from '@angular/core';
import { TranslationEnum } from '../shared/enums/translation-enum';
import { TableCol } from './models/TableCol';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { TableSortService } from './table-sort.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { OrderResponseDialogComponent } from '../module-order-register/order-list/order-warning-dialog/order-response-dialog/order-response-dialog.component';
import { OrderNoteDialogComponent } from '../module-order-register/order-list/order-note-dialog/order-note-dialog.component';
import { UniversalDialogComponent } from '../shared/components/universal-dialog/universal-dialog.component';
import { DialogData } from '../shared/models/dialog/dialog-data.model';

@Component({
  selector: 'app-table-sort',
  templateUrl: './table-sort.component.html',
  styleUrls: ['./table-sort.component.scss']
})
export class TableSortComponent implements OnInit {
  @Input() tableCol: TableCol;
   edit = false;
  public TranslationEnum = TranslationEnum;

public DontRemoveColumns = [
          'B2BId',
          'Produkt',
          'System',
          'Quantity',
          'OrderStatusName',
          'OrderingName'
        ];

  constructor(private tableSortService: TableSortService, public dialog: MatDialog) {
      
   }

  ngOnInit(): void {
  }
  public Edit(edit:boolean) {
    // console.log("tableCol", this.tableCol);
    this.edit = edit;
  }
  public zapisz(){
    this.edit = false;
    // console.log("zapisuje", this.tableCol.ustawione.tableColSave);
    if(this.tableSortService != null){
      this.tableSortService.setSettings(this.tableCol.ustawione.tableColSave).
        subscribe((data) => {
          // console.log("zapisano", data);
        });
    }
  }

  public przywroc(){
    // console.log("przywracam", this.tableCol.ustawione.tableColSave);
    this.tableCol.przywroc();
  }
  


  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      this.tableCol.ustawInne(true, this.tableSortService);
    } else {
      this.transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
      this.tableCol.ustawInne(true, this.tableSortService);
    }
  }
  transferArrayItem(data: string[], data1: string[], previousIndex: number, currentIndex: number) {
    // this.tableCol.DisplayedColumns.push(data1[previousIndex]);
    this.tableCol.DisplayedColumns = this.tableCol.DisplayedColumns.filter(item => item !== data[previousIndex]);   
    this.tableCol.DisplayedColumns.splice(currentIndex, 0, data[previousIndex]);
    this.tableCol.OtherColumns = this.tableCol.OtherColumns.filter(item => item !== data[previousIndex]);   
  }
  dropBack(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      
    } else {
      var jest = this.DontRemoveColumns.find(x => x == this.tableCol.DisplayedColumns[event.previousIndex])
      if(jest == null){
        // console.log("przeniesiono", this.tableCol.OtherColumns[event.previousIndex]);
        this.removeArrayItem(event.previousContainer.data, event.previousIndex, event.currentIndex);
      } else {
        // console.log("nie przeniesiono", this.tableCol.OtherColumns[event.previousIndex]);
         let dialogRef: MatDialogRef<UniversalDialogComponent, any>;
               const data: DialogData = {
                 title: 'pole_wymagane',
                 content: 'popola_nie_da_sie_usunac',
                 answerOk: true,
               };
               dialogRef = this.dialog.open(UniversalDialogComponent, { data: data });
             
      }
      
      
    }
  }
  public removeArrayItem(data, previousIndex: number, currentIndex:number){
    // console.log("name", name);
     //previousContainer = previousContainer.filter(item => item !== previousContainer.data);   
     this.tableCol.OtherColumns.splice(currentIndex, 0, data[previousIndex]);
     this.tableCol.DisplayedColumns.splice(previousIndex, 1);
    
     this.tableCol.ustawInne(true, this.tableSortService);
     // this.tableCol.DisplayedColumns = this.tableCol.DisplayedColumns.filter(item => item !== name[previousIndex]);   
  }
  public delete(name:string){
    this.tableCol.OtherColumns.push(name);
    this.tableCol.DisplayedColumns =  this.tableCol.DisplayedColumns.filter(item => item !== name);  
    
    this.tableCol.ustawInne(true, this.tableSortService);
  }
  public czyUsun(item:string){
    var usun = true;
    this.DontRemoveColumns.forEach(element => {
      if(element == item){
        usun = false;
      }
    });
    return usun;
  }
}
